import { GatewayApi } from "emrn-api/gateway";

/**
 * 登录接口
 * @param request 参数
 */
export function webLogin(request: WebLoginRequest) {
  return GatewayApi.postJSON<WebLoginResponse>("/Customer/webLogin", request);
}

interface WebLoginRequest {
  /**
   * 营业部代码
   */
  Yybdm: string;
  /**
   * 交易密码
   */
  Jymm: string;
  /**
   * 用户标识类型
   */
  User_id_lx: string;
  /**
   * 用户标识
   */
  User_id: string;
  /**
   * 超时时间设置（单位：秒）
   */
  Cssj: string;
  /**
   * 扩展密码
   */
  Ex_pwd?: string;
}

interface WebLoginResponse {
  /**
   * 客户名称
   */
  khmc: string;
  /**
   * 系统日期
   */
  Date: string;
  /**
   * 系统时间
   */
  Time: string;
  /**
   * 系统固定参数1
   */
  Syspm1: string;
  /**
   * 系统固定参数2
   */
  Syspm2: string;
  /**
   * 系统固定参数3
   */
  Syspm3: string;
  /**
   * 系统固定扩展参数,系统登陆时送空,登陆成功后如果返回无该字段,则可送空
   */
  Syspm_ex: string;
}
